import React from "react";
import { Link } from "react-router-dom";
import { Link as Scroll } from "react-scroll";
import { Carousel } from "react-bootstrap";
class HomePageSlider extends React.Component {
  render() {
    const firstItemPath = {
      background: "url(/images/110618-001.jpg)"
    };

    return (
      <section className="bg-home-slider" id="home">
        <div className="container-fluid">
          <div className="row">
            <div
              id="carouselExampleFade"
              className="carousel slide carousel-fade"
              data-ride="carousel"
            >
              <div className="carousel-inner">
                <div
                  className="carousel-item h-100vh active"
                  style={firstItemPath}
                >

                  <div className="home-table">
                    <div className="home-table-center">
                      <div className="container">
                        <div className="row">
                          <div className="col-lg-6 HomeBannerTitle">
                            <div className="">
                              <h1 className="header_title text-left mx-auto">
                                Get WiFi<br/>Anywhere Anytime
                              </h1>
                              <p className="header_subtitleNEW text-left">Since 2003, mightywifi and partners have connected millions of customers worldwide</p>
                              <div className="header_btn text-left">
                                <Link to="/rent" className="btn btn-custom orange mt-4">RENT</Link>
                                <Link to="/buy/device" className="btn btn-custom mt-4">BUY</Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*<div className="carousel-item h-100vh" style={firstItemPath}>
                  <div className="bg-overlay" />
                  <div className="home-table">
                    <div className="home-table-center">
                      <div className="container">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="text-white text-center">
                              <div className=" mb-4 mx-auto" />
                              <h1 className="header_title pt-2 mb-0 font-weight-normal mx-auto">
                                Get WiFi
                                <br />
                                Anywhere
                                <br />
                                Anytime
                              </h1>

                              <div className="header_btn">
                                <Link
                                  to="/get-wifi"
                                  className="btn btn-custom mt-4"
                                >
                                  GET WIFI
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="carousel-item h-100vh" style={firstItemPath}>
                  <div className="bg-overlay" />
                  <div className="home-table">
                    <div className="home-table-center">
                      <div className="container">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="text-white text-center">
                              <div className="mb-4 mx-auto" />
                              <h1 className="header_title pt-2 mb-0 font-weight-normal mx-auto">
                                Get WiFi
                                <br />
                                Anywhere
                                <br />
                                Anytime
                              </h1>

                              <div className="header_btn">
                                <a href="#" className="btn btn-custom mt-4">
                                  GET WIFI
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>*/}
              </div>
              <a
                className="carousel-control-prev"
                href="#carouselExampleFade"
                role="button"
                data-slide="prev"
              >
                <span className="pe-7s-angle-left" aria-hidden="true" />
                <span className="sr-only">Previous</span>
              </a>
              <a
                className="carousel-control-next"
                href="#carouselExampleFade"
                role="button"
                data-slide="next"
              >
                <span className="pe-7s-angle-right" aria-hidden="true" />
                <span className="sr-only">Next</span>
              </a>
            </div>
          </div>
        </div>
        <div className="homettx">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-white text-center">
                <div className="mb-4 mx-auto" />
                <h3 className="pt-2 mb-0 font-weight-normal mx-auto" style={{cursor: 'pointer'}}>
                  <Scroll
                      to="coverages"
                      spy={true}
                      smooth={true}
                      offset={-110}
                      duration= {500}
                  >
                    SINCE 2003, MIGHTYWIFI AND PARTNERS HAVE CONNECTED MILLIONS OF CUSTOMERS WORLDWIDE
                  </Scroll>
                </h3>
              </div>
            </div>
          </div>
        </div>


      {/* <div className="hometbg">
          <div className="container">
            <div className="row">

              <div className="col-lg-3">
                <div className="text-center">
                  <div className="mt-3 about_detail">
                    <h1 className="homebtm">5</h1>
                    <h3 className="homebtmtxt">Share among 5 devices</h3>
                    <span className="homebtmp">
                      Connect your friends and family
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-lg-3">
                <div className="text-center">
                  <div className="mt-3 about_detail">
                    <h1 className="homebtm">$</h1>
                    <h3 className="homebtmtxt">Pay for only what you use</h3>
                    <span className="homebtmp">
                      No contracts. No overage charges
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-lg-3">
                <div className="text-center">
                  <div className="mt-3 about_detail">
                    <h1 className="homebtm">
                      <i className="mdi mdi-rotate-3d" />
                    </h1>
                    <h3 className="homebtmtxt">Unlimited data</h3>
                    <span className="homebtmp">
                      Never worry about running out of data
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-lg-3">
                <div className="text-center">
                  <div className="mt-3 about_detail">
                    <h1 className="homebtm">
                      <i className="mdi mdi-checkbox-marked-circle" />
                    </h1>
                    <h3 className="homebtmtxt">Easy and Secure</h3>
                    <span className="homebtmp">SIM-free, hassle-free</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div> */}

      </section>
    );
  }
}

export default HomePageSlider;



// WEBPACK FOOTER //
// ./src/layout/Carousel.js